import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';

const DEFAULT_PAGE = 1;

/**
 * @description Updates the searchParams in place with the page value set to the default of 1 if useDefaultPage === true. Otherwise set the value from cleanedFilters if exists
 * @param searchParams URLSearchParams
 * @param useDefaultPage boolean
 * @param page number
 */
export const setPage = (
  searchParams: URLSearchParams,
  useDefaultPage: boolean,
  page?: number
): void => {
  if (useDefaultPage) {
    searchParams.set(searchFilterKeysMap.page, DEFAULT_PAGE.toString());
    return;
  }
  if (page) searchParams.set(searchFilterKeysMap.page, page.toString());
};
